<div class="icon-wrapper">
  <svg class="icon">
    <use xlink:href="#user-icon"></use>
  </svg>

  @switch (status) {
    @case ('pending') {
      <svg class="status-indicator">
        <use xlink:href="#waiting-status"></use>
      </svg>
    }
    @case ('success') {
      <svg class="status-indicator">
        <use xlink:href="#green-sign-with-check"></use>
      </svg>
    }
    @case ('failed') {
      <svg class="status-indicator">
        <use xlink:href="#red-sign-with-cross"></use>
      </svg>
    }
  }
</div>
